/** Ad scrapers often store date-only timestamps at midnight UTC (shows as 05:30 in IST). */
export const isDateOnlyTimestamp = (iso) => {
  if (!iso) return true;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return true;
  return d.getUTCHours() === 0 && d.getUTCMinutes() === 0 && d.getUTCSeconds() === 0;
};

export const formatPulseWhen = (iso) => {
  if (!iso) {
    return { primary: '—', secondary: null, isDateOnly: true };
  }
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) {
    return { primary: '—', secondary: null, isDateOnly: true };
  }

  if (isDateOnlyTimestamp(iso)) {
    return {
      primary: d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }),
      secondary: 'Date only (no time in source)',
      isDateOnly: true,
    };
  }

  return {
    primary: d.toLocaleString('en-US', {
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    }),
    secondary: null,
    isDateOnly: false,
  };
};
